/**
 * Phase 3 - Swedish translations module
 */
import enBase from './en.js';
import { translationsSv } from '../../utils/translations/translations.sv.js';
import { plansTranslationsSv } from '../../utils/translations/plans/plansTranslations.sv.js';

const merged = { ...enBase, ...translationsSv, ...plansTranslationsSv };
export default merged;
